import styled from 'styled-components';
import { IconButton } from '@mui/material';

import { Container } from '../../../../../../../components/v2/Card';
import colors from '../../../../../../../styles/colors';

import { fontFamily } from '../../../../../../../styles/text';

/*
 * Row shading for a challenge's enrollment window, matching the offering cards in the lead modal.
 */
const OfferingRowClass = {
  CLOSING_SOON: 'offering-row-closing-soon',
  CLOSED: 'offering-row-closed',
};

/*
 * The page lays its sections out in a height-constrained flex column, and Container opts out of the
 * automatic minimum size by setting overflow, so it would otherwise be shrunk to nothing and the
 * table would never appear.
 */
const TableContainer = styled(Container)`
  flex-shrink: 0;

  /* The grid's default cell padding is what tips this table into a horizontal scroll on a laptop. */
  .MuiDataGrid-cell,
  .MuiDataGrid-columnHeader {
    padding-left: 10px;
    padding-right: 10px;
  }

  .${OfferingRowClass.CLOSING_SOON} {
    background-color: ${colors.shades.danger2};

    &:hover {
      background-color: ${colors.shades.danger4};
    }
  }

  .${OfferingRowClass.CLOSED} {
    background-color: ${colors.shades.gamma5};

    &:hover {
      background-color: ${colors.shades.gamma12};
    }
  }
`;

const OfferingCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.3;
`;

const OfferingSubTitle = styled.span`
  font-family: ${fontFamily.sansSerif};
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
`;

const UnassignedText = styled.span`
  font-family: ${fontFamily.sansSerif};
  font-size: 14px;
  font-style: italic;
  color: rgba(0, 0, 0, 0.45);
`;

const AcceptUntilText = styled.span`
  font-family: ${fontFamily.sansSerif};
  font-size: 12px;
  color: ${colors.base.warning};
`;

const ClosedText = styled(AcceptUntilText)`
  font-weight: 500;
`;

/*
 * Icons rather than labelled buttons: worded actions took enough of the row to push the data
 * columns into a horizontal scroll on a laptop screen.
 */
const ActionButton = styled(IconButton)`
  padding: 6px;
  color: ${colors.shades.gamma10};

  &:hover {
    background-color: ${colors.shades.gamma5};
  }
`;

const RemoveButton = styled(ActionButton)`
  color: ${colors.shades.danger3};

  &:hover {
    background-color: ${colors.shades.danger2};
  }
`;

const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  width: 100%;
`;

export {
  AcceptUntilText,
  ActionButton,
  ActionsCell,
  ClosedText,
  OfferingCell,
  OfferingRowClass,
  OfferingSubTitle,
  RemoveButton,
  TableContainer,
  UnassignedText,
};
